import { create } from "zustand";

import { ForYouSourceEnum } from "@/common/api/services/types";

export enum tabValues {
  FOR_YOU = "forYou",
  TRENDING = "trending",
}

interface IHomeState {
  currentTab?: string;
  setCurrentTab: (currentTab: string) => void;
  forYouSource: ForYouSourceEnum;
  setForYouSource: (forYouSource: ForYouSourceEnum) => void;
}

export const useHomeStore = create<IHomeState>(
  (set) => ({
    forYouSource: ForYouSourceEnum.ALL,

    // actions
    setCurrentTab: (currentTab: string) => set(() => ({ currentTab })),

    setForYouSource: (forYouSource: ForYouSourceEnum) => set(() => ({ forYouSource })),
  }),
);
